import { ICartItem, ICartSummary } from '../../../container/cart/ICart';
import { ERegionBasic } from '../../../types';
import { safeGet } from '../../../utils/objectUtils';
import {
  calculateCartDiscount,
  calculateCartPromotions,
  calculateCartSubTotal,
  calculateCartTotal,
  calculateChildrenTotal,
} from '../../../utils/priceUtils';
import { getRegionFromUri, getUserRegion } from '../../../utils/regionUtils';
import { ILineItem } from './cartInterface';
import { ProductTypes } from './constants';
import { reshapeContactLensData } from './contact-lens/reshapeContactLensData';
import {
  mapProtectionPlanToFrame,
  reshapeFrameData,
  updateCartItems,
} from './frame/reshapeFrameData';
import { reshapeSavingsPlanData } from './savings-plan/reshapeSavingsPlanData';

export const formatPrice = (price: number) => {
  return (Math.round(price * 100) / 100).toFixed(2);
};

export const reshapeCartData = (cart: any) => {
  const resultData = {} as ICartSummary;
  if (!cart || Object.keys(cart)?.length == 0) {
    return resultData;
  }
  const lineItems = cart?.lineItems;
  resultData.total = formatPrice(safeGet(cart, 'totalPrice.centAmount', 0) / 100);
  resultData.receivedTotal = formatPrice(safeGet(cart, 'totalPrice.centAmount', 0) / 100);
  resultData.totalLineItemQuantity = safeGet(cart, 'totalLineItemQuantity', 0);
  if (lineItems && lineItems.length < 1) return resultData;

  const items: ICartItem[] = [];

  lineItems?.forEach((item: ILineItem) => {
    switch (safeGet(item, 'productType.obj.key', '')) {
      case ProductTypes.FRAME: {
        const frame = reshapeFrameData(item, lineItems);
        const mappedFrame = mapProtectionPlanToFrame(frame, lineItems);
        if (mappedFrame) {
          items.push(mappedFrame);
        }
        break;
      }
      case ProductTypes.SAVINGS_PLAN: {
        const savingsPlan = reshapeSavingsPlanData(item);
        items.push(savingsPlan);
        break;
      }
      case ProductTypes.CONTACT_LENS: {
        const contactLens = reshapeContactLensData(item, cart.customLineItems);
        items.push(contactLens);
        break;
      }
      // case ProductTypes.RX: {
      //   const medicines = reshapeMedicinesData(item);
      //   items.push(medicines);
      //   break;
      // }
      default:
        break;
    }
  });

  const resultedCartItems = updateCartItems(items);
  resultedCartItems.forEach((_parentItem, index) => {
    const currentItem = resultedCartItems[index];
    currentItem.childrenLineItems = currentItem?.childrenLineItems?.sort(
      (prev, next) => prev.order - next.order,
    );
    const { childrenLineItems } = currentItem;
    if (childrenLineItems?.length) {
      const price = calculateChildrenTotal(childrenLineItems);
      currentItem.price = formatPrice(price);
    }

    resultedCartItems[index] = currentItem;
  });
  const savings = calculateCartPromotions(cart);
  resultData.savingsPlanDiscount = getSavingPlanDiscount(savings);
  resultData.promotions = getSavingPromotions(savings);
  resultData.benefits = getPriceDiscountByProp(savings, 'benefits');
  resultData.employeeDiscount = getPriceDiscountByProp(savings, 'discounts');
  resultData.cartItems = resultedCartItems;
  resultData.subTotal = calculateCartSubTotal(resultData.cartItems);
  resultData.savings = calculateCartDiscount(cart);
  resultData.total = calculateCartTotal(resultData);
  resultData.cartItemsCount = getTotalCartItemQty(resultedCartItems);

  return resultData;
};

export const getPriceDiscountByProp = (
  savings: any,
  prop: 'promotions' | 'discounts' | 'benefits',
) => {
  if (savings[prop]) {
    return formatPrice(savings[prop] / 100);
  }
  return '0.00';
};

export const getSavingPlanDiscount = (savings: any) => {
  const region = getUserRegion(getRegionFromUri()) as ERegionBasic;
  if (region == ERegionBasic.NCAL) {
    return getPriceDiscountByProp(savings, 'promotions');
  }
  return '0.00';
};

export const getSavingPromotions = (savings: any) => {
  const region = getUserRegion(getRegionFromUri()) as ERegionBasic;
  if (region == ERegionBasic.SCAL) {
    return getPriceDiscountByProp(savings, 'promotions');
  }
  return '0.00';
};

const getTotalCartItemQty = (items: any) => {
  let total = 0;
  items.map((item: any) => {
    let quantity = item.qty ? Number(item.qty) : 1;
    total += quantity;
  });
  return total;
};
